/**
 * useTurnstile Hook
 * Manages Turnstile token state for forms
 */

import { useState, useCallback, useRef } from 'react';

export const useTurnstile = () => {
  const [turnstileToken, setTurnstileToken] = useState('');
  const turnstileResetRef = useRef<(() => void) | null>(null);

  const onVerify = useCallback((token: string) => {
    setTurnstileToken(token);
  }, []);

  const resetTurnstile = useCallback(() => {
    setTurnstileToken('');
    turnstileResetRef.current?.();
  }, []);

  const isTurnstileReady = !!turnstileToken || !import.meta.env.VITE_TURNSTILE_SITE_KEY;

  return {
    turnstileToken,
    onVerify,
    resetTurnstile,
    isTurnstileReady,
    turnstileResetRef,
  };
};
